

/**时间转换 time date dateTime  */
function dateChange(type, time) {
	let data = new Date(time);
	let newDate = data.getFullYear() + '-' + add(data.getMonth() + 1) + '-' + add(data.getDate())
	let newTime = add(data.getHours()) + ':' + add(data.getMinutes()) + ':' + add(data.getSeconds())
	let newDateTime = newDate + ' ' + newTime
	if (type == 'time') {
		return newTime
	}
	if (type == 'date') {
		return newDate
	}
	if (type == 'dateTime') {
		return newDateTime
	}
}

/**时间转换 time date dateTime  */
function toFixn(number, n) {
	let numberStr = number + "";
	let reg = /^(-|\+)?(\d+(\.\d*)?|\.\d+)$/i;
	if (!reg.test(numberStr)) {
		console.error('输入的数字格式不对');
		return number;
	}
	let sign = numberStr.charAt(0) === '-' ? (numberStr = numberStr.slice(1), -1) : 1; // 判断是否是负数
	let pointIndex = numberStr.indexOf("."); // 记录小数点的位置
	if (pointIndex > -1) {
		numberStr = numberStr.replace(".", "");
	} else { // 没有小数点直接添加补0；
		if (n > 0) {
			numberStr += ".";
		}
		numberStr += new Array(n + 1).join('0');
		return sign === -1 ? '-' + numberStr : numberStr;
	}
	let numberArray = numberStr.split(""); //转成数组
	let len = numberArray.length;
	let oldPointNum = len - pointIndex; // 获取原数据有多少位小数
	if (oldPointNum < n) { // 要保留的小数点比原来的要大，直接补0
		while (n - oldPointNum > 0) {
			numberArray.push(0);
			n--;
		}
	} else if (oldPointNum > n) { // 模拟四舍五入

		let i = oldPointNum - n; // 从倒数第i个数字开始比较
		let more = numberArray[len - i] >= 5 ? true : false;
		while (more) {
			i++;
			more = +numberArray[len - i] + 1 === 10 ? true : false; // 进位后判断是否等于10，是则继续进位
			numberArray[len - i] = more && i !== (len + 1) ? 0 : +numberArray[len - i] + 1; // 其他位置的数字进位直接变成0，第一位的例外
		}
		numberArray.length = len - (oldPointNum - n); // 截取多余的小数
	}
	if (n > 0) {
		numberArray.splice(pointIndex, 0, ".");
	}
	// // 如果数组最后以为是'.',删除掉最后一位
	// if(numberArray[numberArray.length-1] == "."){
	// 	numberArray.pop()
	// }
	return sign === -1 ? '-' + numberArray.join("") : numberArray.join("");
}
/**拼接字符串 */
//  function add(p){
//     if(p<10){
//         return '0'+p
//     }
//     return p
// }

// 获取当前时间
function getDates() {
	var date = new Date()
	var date = new Date()
	var seperator1 = "-"
	var year = date.getFullYear()
	var month = date.getMonth() + 1
	var strDate = date.getDate()
	if (month >= 1 && month <= 9) {
		month = "0" + month
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate
	}
	var currentdate = year + seperator1 + month + seperator1 + strDate
	return currentdate
}
/**
 * @function 生成树结构
 * @param arr 要转的数组
 */

function getSortTree(arr) {
	let list = arr.reduce(function (prev, item) {
		prev[item.fparentid] ? prev[item.fparentid].push(item) : prev[item.fparentid] = [item];
		return prev
	}, {});
	for (let key in list) {
		list[key].forEach(function (item) {
			if (item.fgroupid) {
				item.children = list[item.fgroupid] ? list[item.fgroupid] : [];
			}
			if (item.fsubid) {
				item.children = list[item.fsubid] ? list[item.fsubid] : [];
			}
		});
	}
	return list[0]
}

/**@function get拼接
 * @url 接口地址
 * @params 参数对象
 * @author f
 */
function getParamUrl(url, params) {
	let paraStr = url + "?";
	for (const key in params) {
		if (params.hasOwnProperty(key)) {
			const element = params[key];
			let str = key + "=" + element + "&";
			paraStr += str;
		}
	}
	return paraStr;
}
// 永不重复的随机数
function getUuid(length) {
	if (length > 0) {
		var data = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
		var nums = "";
		for (var i = 0; i < length; i++) {
			var r = parseInt(Math.random() * 61);
			nums += data[r];
		}
		return nums;
	} else {
		return false;
	}
}

/**时间转换 time date dateTime  */
export function dateChange1(type, time) {
	let data = new Date(time);
	let newDate = data.getFullYear() + '-' + add(data.getMonth() + 1) + '-' + add(data.getDate())
	let newTime = add(data.getHours()) + ':' + add(data.getMinutes()) + ':' + add(data.getSeconds())
	let newDateTime = newDate + ' ' + newTime
	if (type == 'time') {
		return newTime
	}
	if (type == 'date') {
		return newDate
	}
	if (type == 'dateTime') {
		return newDateTime
	}
}
/**拼接字符串 */
export function add(p) {
	if (p < 10) {
		return '0' + p
	}
	return p
}


/**
 * @function 清空数组中的空children
 * @param arr 要清空的数组
 */

export function delEmptyChild(arr) {
	let brr = []
	for (let el of arr) {
		if (JSON.stringify(el.children) == '[]') {
			delete el.children
		} else {
			delEmptyChild(el.children)
		}
		brr.push(el)
	}
	return brr
}



// #############################################
//                 表格样式
// 小唐 ---------------------------新增方法start
export function cellStyleTop(row, rowIndex, column, columnIndex, cellclass, gridline, rowstyledata, type) {
	for (let i = 0; i < cellclass.length; i++) {
		if (rowIndex == cellclass[i].rowindex && columnIndex == cellclass[i].colindex) {
			let cellstyleobj = setstyle1(cellclass[i].value);
			if (gridline.visible == true) {
				let style = gridline.style
				let color = gridline.color
				let size = Math.abs(gridline.size)
				if (style == 'solid' || style == 'dotted') {
					cellstyleobj = {
						...cellstyleobj,
						borderBottom: `${size}px ${style} ${color}`,
						borderRight: `${size}px ${style} ${color}`
					}
					if (columnIndex == -1) {
						cellstyleobj = {
							...cellstyleobj,
							borderLeft: `${size}px ${style} ${color}`,
						}
					}
					// type 用于区分有没有表头
					if (type == 'noHead') {
						if (rowIndex == 0) {
							cellstyleobj = {
								...cellstyleobj,
								borderTop: `${size}px ${style} ${color}`,
							}
						}
					}
					if (columnIndex == 0) {
						cellstyleobj = {
							...cellstyleobj,
							borderLeft: `${size}px ${style} ${color}`,
						}
					}

				} else if (style == 'hengSolid') {// 横实
					cellstyleobj = {
						...cellstyleobj,
						borderBottom: `${size}px solid ${color}`,
					}
					// type 用于区分有没有表头
					if (type == 'noHead') {
						if (rowIndex == 0) {
							cellstyleobj = {
								...cellstyleobj,
								borderTop: `${size}px solid ${color}`,
							}
						}
					}

				} else if (style == 'hengDotted') { // 横虚
					cellstyleobj = {
						...cellstyleobj,
						borderBottom: `${size}px dotted ${color}`,
					}
					// type 用于区分有没有表头
					if (type == 'noHead') {
						if (rowIndex == 0) {
							cellstyleobj = {
								...cellstyleobj,
								borderTop: `${size}px dotted ${color}`,
							}
						}
					}

				} else if (style == 'shuSolid') {
					cellstyleobj = {
						...cellstyleobj,
						borderRight: `${size}px solid ${color}`,
					}
					if (columnIndex == 0) {
						cellstyleobj = {
							...cellstyleobj,
							borderLeft: `${size}px solid ${color}`,
						}
					}

					if (rowIndex == 0) {
						cellstyleobj = {
							...cellstyleobj,
							borderRight: `${size}px solid ${color}`,
						}
					}

				} else if (style == 'shuDotted') {

					cellstyleobj = {
						...cellstyleobj,
						borderRight: `${size}px dotted ${color}`,
					}
					if (columnIndex == 0) {
						cellstyleobj = {
							...cellstyleobj,
							borderLeft: `${size}px dotted ${color}`,
						}
					}
					if (rowIndex == 0) {
						cellstyleobj = {
							...cellstyleobj,
							borderRight: `${size}px dotted ${color}`,
						}
					}
				}
			} else {
				cellstyleobj = setstyle1(cellclass[i].value)
			}
			cellstyleobj = {
				...cellstyleobj,
				height: rowstyledata.height + "px"
			}
			return cellstyleobj;
		}
	}
	let styleobj = {}
	if (gridline.visible == true) {
		let style = gridline.style
		let color = gridline.color
		let size = Math.abs(gridline.size)
		if (style == 'solid' || style == 'dotted') {
			styleobj = {
				borderBottom: `${size}px ${style} ${color}`,
				borderRight: `${size}px ${style} ${color}`
			}
			if (columnIndex == 0) {
				styleobj = {
					...styleobj,
					borderLeft: `${size}px ${style} ${color}`,
				}
			}
			// type 用于区分有没有表头
			if (type == 'noHead') {
				if (rowIndex == 0) {
					styleobj = {
						...styleobj,
						borderTop: `${size}px ${style} ${color}`,
					}
				}
			}

		} else if (style == 'hengSolid') {
			styleobj = {
				borderBottom: `${size}px solid ${color}`,
			}
			// type 用于区分有没有表头
			if (type == 'noHead') {
				if (rowIndex == 0) {
					styleobj = {
						...styleobj,
						borderTop: `${size}px solid ${color}`,
					}
				}
			}

		} else if (style == 'hengDotted') {
			styleobj = {
				borderBottom: `${size}px dotted ${color}`,
			}
			if (type == 'noHead') {
				if (rowIndex == 0) {
					styleobj = {
						...styleobj,
						borderTop: `${size}px dotted ${color}`,
					}
				}
			}

		} else if (style == 'shuSolid') {
			styleobj = {
				borderRight: `${size}px solid ${color}`
			}
			if (columnIndex == 0) {
				styleobj = {
					...styleobj,
					borderLeft: `${size}px solid ${color}`
				}
			}
		} else if (style == 'shuDotted') {
			styleobj = {
				borderRight: `${size}px dotted ${color}`
			}
			if (columnIndex == 0) {
				styleobj = {
					...styleobj,
					borderLeft: `${size}px dotted ${color}`
				}
			}
		}

		styleobj = {
			...styleobj,
			height: rowstyledata.height + 'px'
		}

	} else {
		styleobj = {
			height: rowstyledata.height + 'px'
		}
	}
	return styleobj;
}
export function cellStyle(row, rowIndex, column, columnIndex, cellclass, gridline, rowstyledata, type) {
	for (let i = 0; i < cellclass.length; i++) {
		// if(rowIndex == cellclass[i].rowindex && columnIndex == cellclass[i].colindex){
		if (column.property === cellclass[i].label) {
			let cellstyleobj = setstyle1(cellclass[i].value);
			if (gridline.visible == true) {
				let style = gridline.style
				let color = gridline.color
				let size = Math.abs(gridline.size)
				if (style == 'solid' || style == 'dotted') {
					cellstyleobj = {
						...cellstyleobj,
						borderBottom: `${size}px ${style} ${color}`,
						borderRight: `${size}px ${style} ${color}`
					}
					if (columnIndex == -1) {
						cellstyleobj = {
							...cellstyleobj,
							borderLeft: `${size}px ${style} ${color}`,
						}
					}
					// type 用于区分有没有表头
					if (type == 'noHead') {
						if (rowIndex == 0) {
							cellstyleobj = {
								...cellstyleobj,
								borderTop: `${size}px ${style} ${color}`,
							}
						}
					}
					if (columnIndex == 0) {
						cellstyleobj = {
							...cellstyleobj,
							borderLeft: `${size}px ${style} ${color}`,
						}
					}

				} else if (style == 'hengSolid') {// 横实
					cellstyleobj = {
						...cellstyleobj,
						borderBottom: `${size}px solid ${color}`,
					}
					// type 用于区分有没有表头
					if (type == 'noHead') {
						if (rowIndex == 0) {
							cellstyleobj = {
								...cellstyleobj,
								borderTop: `${size}px solid ${color}`,
							}
						}
					}

				} else if (style == 'hengDotted') { // 横虚
					cellstyleobj = {
						...cellstyleobj,
						borderBottom: `${size}px dotted ${color}`,
					}
					// type 用于区分有没有表头
					if (type == 'noHead') {
						if (rowIndex == 0) {
							cellstyleobj = {
								...cellstyleobj,
								borderTop: `${size}px dotted ${color}`,
							}
						}
					}

				} else if (style == 'shuSolid') {
					cellstyleobj = {
						...cellstyleobj,
						borderRight: `${size}px solid ${color}`,
					}
					if (columnIndex == 0) {
						cellstyleobj = {
							...cellstyleobj,
							borderLeft: `${size}px solid ${color}`,
						}
					}

					if (rowIndex == 0) {
						cellstyleobj = {
							...cellstyleobj,
							borderRight: `${size}px solid ${color}`,
						}
					}

				} else if (style == 'shuDotted') {

					cellstyleobj = {
						...cellstyleobj,
						borderRight: `${size}px dotted ${color}`,
					}
					if (columnIndex == 0) {
						cellstyleobj = {
							...cellstyleobj,
							borderLeft: `${size}px dotted ${color}`,
						}
					}
					if (rowIndex == 0) {
						cellstyleobj = {
							...cellstyleobj,
							borderRight: `${size}px dotted ${color}`,
						}
					}
				}
			} else {
				cellstyleobj = setstyle1(cellclass[i].value)
			}
			cellstyleobj = {
				...cellstyleobj,
				height: rowstyledata.height + "px"
			}
			return cellstyleobj;
		}
	}
	let styleobj = {}
	if (gridline.visible == true) {
		let style = gridline.style
		let color = gridline.color
		let size = Math.abs(gridline.size)
		if (style == 'solid' || style == 'dotted') {
			styleobj = {
				borderBottom: `${size}px ${style} ${color}`,
				borderRight: `${size}px ${style} ${color}`
			}
			if (columnIndex == 0) {
				styleobj = {
					...styleobj,
					borderLeft: `${size}px ${style} ${color}`,
				}
			}
			// type 用于区分有没有表头
			if (type == 'noHead') {
				if (rowIndex == 0) {
					styleobj = {
						...styleobj,
						borderTop: `${size}px ${style} ${color}`,
					}
				}
			}

		} else if (style == 'hengSolid') {
			styleobj = {
				borderBottom: `${size}px solid ${color}`,
			}
			// type 用于区分有没有表头
			if (type == 'noHead') {
				if (rowIndex == 0) {
					styleobj = {
						...styleobj,
						borderTop: `${size}px solid ${color}`,
					}
				}
			}

		} else if (style == 'hengDotted') {
			styleobj = {
				borderBottom: `${size}px dotted ${color}`,
			}
			if (type == 'noHead') {
				if (rowIndex == 0) {
					styleobj = {
						...styleobj,
						borderTop: `${size}px dotted ${color}`,
					}
				}
			}

		} else if (style == 'shuSolid') {
			styleobj = {
				borderRight: `${size}px solid ${color}`
			}
			if (columnIndex == 0) {
				styleobj = {
					...styleobj,
					borderLeft: `${size}px solid ${color}`
				}
			}
		} else if (style == 'shuDotted') {
			styleobj = {
				borderRight: `${size}px dotted ${color}`
			}
			if (columnIndex == 0) {
				styleobj = {
					...styleobj,
					borderLeft: `${size}px dotted ${color}`
				}
			}
		}

		styleobj = {
			...styleobj,
			height: rowstyledata.height + 'px'
		}

	} else {
		styleobj = {
			height: rowstyledata.height + 'px'
		}
	}
	return styleobj;
}
//   表尾 单元格样式
export function footercell(row, rowIndex, column, columnIndex, footerstyledata, gridline) {
	let styleobj = setstyle1(footerstyledata);
	if (gridline.visible == true) {
		let style = gridline.style
		let color = gridline.color
		let size = Math.abs(gridline.size)
		if (style == 'solid' || style == 'dotted') {
			if (columnIndex == 0) {
				styleobj = {
					...styleobj,
					borderLeft: `${size}px ${style} ${color}`,
				}
			}
			styleobj = {
				...styleobj,
				// borderLeft:`${size}px ${style} ${color}`,
				borderRight: `${size}px ${style} ${color}`,
				borderTop: `${size}px ${style} ${color}`,
				borderBottom: `${size}px ${style} ${color}`
			}
		} else if (style == 'hengSolid') {
			styleobj = {
				...styleobj,
				borderTop: `${size}px solid ${color}`,
				borderBottom: `${size}px solid ${color}`,
			}
		} else if (style == 'hengDotted') {
			styleobj = {
				...styleobj,
				borderTop: `${size}px dotted ${color}`,
				borderBottom: `${size}px dotted ${color}`,
			}
		} else if (style == 'shuSolid') {
			if (columnIndex == 0) {
				styleobj = {
					...styleobj,
					borderLeft: `${size}px solid ${color}`,
				}
			}
			styleobj = {
				...styleobj,
				borderRight: `${size}px solid ${color}`,
			}
		} else if (style == 'shuDotted') {
			if (columnIndex == 0) {
				styleobj = {
					...styleobj,
					borderLeft: `${size}px dotted ${color}`,
				}
			}
			styleobj = {
				...styleobj,
				borderRight: `${size}px dotted ${color}`,
			}
		}
	}
	return styleobj;
}
// 表头样式
export function headerCellStyle(row, rowIndex, column, columnIndex, headerstyledata, gridline) {
	// 表头需要默认文字居中
	let styleobj = setstyle1(headerstyledata);
	let style = gridline.style
	let color = gridline.color
	let size = Math.abs(gridline.size)
	if (gridline.visible == true) {
		if (style == 'solid' || style == 'dotted') {
			styleobj = {
				...styleobj,
				borderBottom: `${size}px ${style} ${color}`,
				borderRight: `${size}px ${style} ${color}`,
				borderTop: `${size}px ${style} ${color}`
			}
			if (columnIndex == 0) {
				styleobj = {
					...styleobj,
					borderLeft: `${size}px ${style} ${color}`,
				}
			}
		} else if (style == 'hengSolid') {
			styleobj = {
				...styleobj,
				borderTop: `${size}px solid ${color}`,
				borderBottom: `${size}px solid ${color}`,
			}
		} else if (style == 'hengDotted') {
			styleobj = {
				...styleobj,
				borderTop: `${size}px dotted ${color}`,
				borderBottom: `${size}px dotted ${color}`,
			}
		} else if (style == 'shuSolid') {
			styleobj = {
				...styleobj,
				borderRight: `${size}px solid ${color}`,
			}
			if (columnIndex == 0) {
				styleobj = {
					...styleobj,
					borderLeft: `${size}px solid ${color}`,
				}
			}
		} else if (style == 'shuDotted') {

			styleobj = {
				...styleobj,
				borderRight: `${size}px dotted ${color}`,
			}
			if (columnIndex == 0) {
				styleobj = {
					...styleobj,
					borderLeft: `${size}px dotted ${color}`,
				}
			}
		}
	}
	styleobj = {
		...styleobj,
		textAlign: "center",
	}
	return styleobj;
}
// 表尾行样式
export function footerStyle(row, rowIndex, column, columnIndex, footerstyledataTwo, gridline) {
	let styleobj = setstyle1(footerstyledataTwo);
	if (gridline.visible == true) {
		if (gridline.style == 'solid' || gridline.style == 'dotted') {
			styleobj = {
				...styleobj,
				borderRight: Math.abs(gridline.size) + "px " + gridline.style + " " + gridline.color,
				borderTop: Math.abs(gridline.size) + "px " + gridline.style + " " + gridline.color,
				borderBottom: Math.abs(gridline.size) + "px " + gridline.style + " " + gridline.color
			}
		} else if (gridline.style == 'hengSolid') {
			styleobj = {
				...styleobj,
				borderTop: Math.abs(gridline.size) + "px solid" + gridline.color,
				borderBottom: Math.abs(gridline.size) + "px solid" + gridline.color,
			}
		} else if (gridline.style == 'hengDotted') {
			styleobj = {
				...styleobj,
				borderTop: Math.abs(gridline.size) + "px dotted" + gridline.color,
				borderBottom: Math.abs(gridline.size) + "px dotted" + gridline.color,
			}
		} else if (gridline.style == 'shuSolid') {
			styleobj = {
				...styleobj,
				borderRight: Math.abs(gridline.size) + "px solid" + gridline.color,
			}
		} else if (gridline.style == 'shuDotted') {
			styleobj = {
				...styleobj,
				borderRight: Math.abs(gridline.size) + "px dotted" + gridline.color,
			}
		}
	}
	return styleobj;
}

export function getItemValue(obj) {
	let headerstyledata = {
		height: 30,          //高度
		backcolor: "#fff", //背景色
		fontcolor: "#666",           //字体颜色
		padding: 0,              //内边距（默认去掉表格的上下边距）
		fontbold: false,         //粗体
		fontsize: 14,            //字体大小
		fontitalic: false,     //是否斜体
		fontstrikeout: false,  //是否需要中划线
		fontunderline: false,  //是否需要下划线
	}
	let rowstyledata = {
		height: 30,          //高度
		backcolor: "#fff", //背景色
		fontcolor: "#666",           //字体颜色
		padding: 0,              //内边距（默认去掉表格的上下边距）
		fontbold: false,         //粗体
		fontsize: 14,            //字体大小
		fontitalic: false,     //是否斜体
		fontstrikeout: false,  //是否需要中划线
		fontunderline: false,  //是否需要下划线
	}
	let footerstyledata = {
		height: 30,          //高度
		backcolor: "#fff", //背景色
		fontcolor: "#666",           //字体颜色
		padding: 0,              //内边距（默认去掉表格的上下边距）
		fontbold: false,         //粗体
		fontsize: 14,            //字体大小
		fontitalic: false,     //是否斜体
		fontstrikeout: false,  //是否需要中划线
		fontunderline: false,  //是否需要下划线
	}
	if (obj.look.list) {
		if (obj.look.list.header) {
			headerstyledata = {
				height: obj.look.list.header.height,
				fontbold: obj.look.list.header.font.bold,
				fontsize: obj.look.list.header.font.size,
				fontcolor: obj.look.list.header.font.color,
				fontitalic: obj.look.list.header.font.italic,
				fontstrikeout: obj.look.list.header.font.strikeout,
				fontunderline: obj.look.list.header.font.underline,
				backcolor: obj.look.list.header.backcolor,
			}
		}
		if (obj.look.list.detail) {

			rowstyledata = {
				height: obj.look.list.detail.height,
				fontbold: obj.look.list.detail.font.bold,
				fontsize: obj.look.list.detail.font.size,
				fontcolor: obj.look.list.detail.font.color,
				fontitalic: obj.look.list.detail.font.italic,
				fontstrikeout: obj.look.list.detail.font.strikeout,
				fontunderline: obj.look.list.detail.font.underline,
				backcolor: obj.look.list.detail.backcolor,
			}
		}
		if (obj.look.list.footer) {
			footerstyledata = {
				footer: obj.look.list.footer.visible,
				height: obj.look.list.footer.height,
				fontbold: obj.look.list.footer.font.bold,
				fontsize: obj.look.list.footer.font.size,
				fontcolor: obj.look.list.footer.font.color,
				fontitalic: obj.look.list.footer.font.italic,
				fontstrikeout: obj.look.list.footer.font.strikeout,
				fontunderline: obj.look.list.footer.font.underline,
				backcolor: obj.look.list.footer.backcolor,
			}
		}
	}

	let objValue = {
		headerstyledata: headerstyledata,
		rowstyledata: rowstyledata,
		footerstyledata: footerstyledata
	}
	return objValue
}
// 获取数据并处理
export function getItem(i) {
	if (i.data.readtext == "fdateplan") {
		console.log(i)
	}
	if (i.data.readtext == "fdatedecide") {
		console.log(i)
	}

	let v = {}
	v.authState = i.auth ? {} : i.auth.state
	v.authKeyword = i.auth ? {} : i.auth.keyword
	v.datalistApi = i.data.list.api
	v.dataapikeyword = i.data.list.apikeyword
	v.editRender = {
		name: i.look.editRender ? i.look.editRender.name : "",
		options: i.data.list.prelist,
		autoselect: true,
		attrs: i.look.attrs,
		slots: i.look.editRender ? { ...i.look.editRender.slots } : {},
	}
	// if(i.data.readtext=='fbatchno'){
	// 	v.editRender.autoselect=false
	// }
	if (i.look.editRender) {
		v.editRender.props = i.look.editRender.props ? i.look.editRender.props : {}
		v.slots = i.look.editRender.slots ? i.look.editRender.slots : {}
	}
	v.prelist = i.data.list.prelist
	v.readcode = i.data.readcode
	v.readtext = i.data.readtext
	v.savecode = i.data.savecode
	v.savetext = i.data.savetext
	v.joinlistApi = i.join.data.api
	v.joinapikeyword = i.join.data.apikeyword
	v.joinList = i.join.list
	v.bold = i.look.font.bold
	v.size = i.look.font.size
	v.color = i.look.font.color
	v.italic = i.look.font.italic
	v.strikeout = i.look.font.strikeout
	v.underline = i.look.font.underline
	v.backcolor = i.look.backcolor
	v.width = i.look.width
	v.minwidth = i.look.minwidth
	v.enable = i.look.enable
	v.export = i.look.export
	v.align = i.look.align
	v.footer = i.look.footer
	v.resize = i.look.resize
	v.visible = i.look.visible
	v.datatype = i.look.datatype
	v.sortable = i.look.sortable
	v.precision = i.look.precision
	v.state = i.state
	v.usage = i.usage
	v.caption = i.caption
	v.field = i.data.readtext
	v.title = i.caption
	v.params = { data: i }
	let dataObj = {
		backcolor: i.look.backcolor,
		bold: i.look.font.bold,
		color: i.look.font.color,
		italic: i.look.font.italic,
		size: i.look.font.size,
		strikeout: i.look.font.strikeout,
		underline: i.look.font.underline,
		height: i.look.font.height,
		padding: 0,
	}
	let obj = {
		v: v,
		dataObj: dataObj
	}
	return obj;
}

// 处理列表数据 （保存的时候）
export function chuliValue(arrlist, v) {
	let obj = {
		"id": arrlist.length++,//内码（新增一列时，根据总列数生成，生成后一般允许修改）
		"index": arrlist.length++,//（显示的顺序）
		"auth": {//权限类控制
			"state": v.authState ? v.authState : false,//是否启用权限控制
			"keyword": v.authKeyword ? v.authKeyword : ''//描述权限的关键字
		},
		"data": {//数据类
			"list": {//如果是下拉框类，需要预读数据，这里定义的是预读数据时的取数来源
				"api": v.datalistApi ? v.datalistApi : '',//数据来源于API时的api
				"apikeyword": v.dataapikeyword ? v.dataapikeyword : '',//数据来源于API时传递给API的关键字
				"prelist": v.prelist ? v.prelist : []//下拉框列表的数据
			},
			"readcode": v.readcode ? v.readcode : '',//读取的内码字段
			"readtext": v.readtext ? v.readtext : v.field,//读取的文字字段
			"savecode": v.savecode ? v.savecode : '',//保存的内码字段
			"savetext": v.savetext ? v.savetext : ''//保存的文字字段
		},
		"join": {//数据之间的关联性，即本列数据变动的方式以及导致的连锁反应
			"data": {//本列数据变动的取数方式，比如本列数据变动，就会调用API取数
				"api": v.joinlistApi ? v.joinlistApi : '',//数据来源于API时的api
				"apikeyword": v.joinapikeyword//数据来源于API时传递给API的关键字
			},
			"list": v.joinList
		},
		"look": {//外观
			"font": {//字体
				"bold": v.fontbold,//字体是否重体
				"size": v.fontsize,//字体大小
				"color": v.fontcolor,//字体前景色
				"italic": v.fontitalic,//字体是否斜体
				"strikeout": v.fontstrikeout,//字体是否需要中划线
				"underline": v.fontunderline,//字体是否需要下划线
			},
			"backcolor": v.backcolor, // 背景色
			"width": v.width,//列宽
			"minwidth": v.minwidth,//最小列宽
			"enable": v.enable,//列是否有效
			"align": v.align,//本列文本靠左靠右，支持 left|center|right 三种
			"footer": v.footer,//本列汇总行
			"resize": v.resize,//本列可调整列宽
			"visible": v.visible,//本列是否可见
			"attrs": v.editRender ? v.editRender.attrs : {},
			"editRender": v.editRender ? v.editRender : {},
			"slots": v.slots,//状态
			"datatype": v.datatype,//本列的数据类型，支持 text(文本)、int(整数，同时支持posint正整数、negint负整数)、float(浮点数，同时支持posfloat正数、negfloat负数)、bool(布尔数，对应√用)、date(日期 选择框)、textbtn(右侧带小按钮的文本)、button(纯按钮)、list(不可编辑下拉框)、listedit(可编辑下拉框)
			"sortable": v.sortable,//本列是否支持排序
			"precision": v.precision//本列的数字精度（针对float类使用）
		},
		"state": v.state,//状态
		"usage": v.usage,//应用标识（由设置人员填写，表示该列的特殊用途）
		"caption": v.caption ? v.caption : v.title//列标题
	}
	return obj
}
// 转换成渲染的样式
export function setstyle1(data) {
	let styleobj = {};
	styleobj.height = data.height ? data.height : 30 + "px";
	styleobj.backgroundColor = data.backcolor;
	styleobj.color = data.color;
	styleobj.padding = 0;
	if (data.bold == true) {
		styleobj.fontWeight = 600;
	} else {
		styleobj.fontWeight = 500;
	}
	styleobj.fontSize = data.size ? data.size + 'px' : 14 + "px";
	if (data.italic == true) { // 斜体
		styleobj.fontStyle = "italic";
	} else {
		styleobj.fontStyle = "normal";
	}
	if (data.strikeout != undefined && data.underline != undefined) {
		if (data.strikeout == true && data.underline == false) {
			styleobj.textDecoration = "line-through";
		} else if (data.strikeout == false && data.underline == true) {
			styleobj.textDecoration = "underline";
		} else if (data.strikeout == false && data.underline == false) {
			styleobj.textDecoration = "none";
		} else {
			styleobj.textDecoration = "underline";
		}
	} else {
		styleobj.textDecoration = "none";
	}
	return styleobj;
}

/**
 * // 二级表头事件
 * fMerge：需要合并的列数据（开始结束和标题名称）
 * merge:数组
 * tableColumn:列数组
 * */
export function TwoTableHead(merge, fMerge, tableColumn) {
	console.log("merge", merge)
	let arr = []
	let num = fMerge.end - fMerge.beg // 取差值
	for (let v = 0; v < num; v++) {                                                    // 取子集数组
		let index = Number(fMerge.beg) + Number(v)
		arr.push(tableColumn[index])
	}
	let obj = {
		title: fMerge.caption,
		children: arr
	}
	tableColumn.splice(fMerge.beg, num, obj)
	let mergeObj = {
		"caption": fMerge.caption,
		"beg": fMerge.beg,//开始列
		"end": fMerge.end//合并到列
	}
	merge.push(mergeObj)
	let objs = {
		merge: merge,
		tableColumn: tableColumn
	}
	return objs
}
/**
 * // 撤销二级表头 
 * fMerge：需要合并的列数据（开始结束和标题名称）
 * merge:数组
 * tableColumn:列数组
 * */
export function TwoTableHeadundo(merge, fMerge, tableColumn) {
	let indexxx = merge.findIndex(tag => {
		return tag.end == fMerge.end && tag.beg == fMerge.beg
	})
	if (indexxx == -1) {
		// this.$message.error('请输入符合撤销的开始列与结束列')
		let index = merge[merge.length - 1].beg
		tableColumn.splice(index, 1, ...tableColumn[index].children)
		merge.splice(indexxx, 1)
	} else {
		let index = merge[indexxx].beg
		tableColumn.splice(index, 1, ...tableColumn[index].children)
		merge.splice(indexxx, 1)
	}
	let obj = {
		merge: merge,
		tableColumn: tableColumn
	}
	return obj
}
/**
 * 渲染二级表头
 * merge：二级表头数据数组
 * tableColumn：列表数组
 * **/
export function showTwoTableHead(merge, tableColumn) {
	for (let i of merge) {
		let num = i.end - i.beg
		let arr = []
		for (let v = 0; v < num; v++) {                                                    // 取子集数组
			let index = Number(i.beg) + Number(v)
			arr.push(tableColumn[index])
		}
		let obj = {
			title: i.caption,
			children: arr
		}
		tableColumn.splice(i.beg, num, obj)
	}
	return tableColumn
}
// #############################################

const unit = {
	dateChange: dateChange,
	getSortTree: getSortTree,
	getParamUrl: getParamUrl,
	getDates: getDates,
	getUuid: getUuid,
	delEmptyChild: delEmptyChild,
	headerCellStyle: headerCellStyle,
	footercell: footercell,
	cellStyle: cellStyle,
	setstyle: setstyle1,
	footerStyle: footerStyle,
	getItemValue: getItemValue,
	getItem: getItem,
	cellStyleTop: cellStyleTop,
	chuliValue: chuliValue,
	TwoTableHead: TwoTableHead,
	TwoTableHeadundo: TwoTableHeadundo,
	showTwoTableHead: showTwoTableHead,
	toFixn: toFixn

}

export default unit //导出



// WEBPACK FOOTER //
// ./src/assets/unit/unit.js